<div
  class="card-image"
  [ngStyle]="{
    'background-image': 'url(' + image + ')'
  }"
></div>
